// extracted by mini-css-extract-plugin
export default {"login":"Login_login__3cJrA","buttonBorder":"Login_buttonBorder__T2M-r"};